<template>
  <div
    row
    wrap
    class="user-detail-component"
  >
    <v-expansion-panel
      v-model="panel"
      class="my-2"
      expand
    >
      <!-- Information User Metadata -->
      <v-expansion-panel-content>
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            Metadata Information
          </h6>
        </template>
        <v-layout>
          <v-spacer />

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                fixed
                dark
                fab
                bottom
                right
                color="warning"
                :disabled="!unsavedData"
                v-on="on"
                @click="openSaveUserDataModal"
              >
                <v-icon>save</v-icon>
              </v-btn>
            </template>
            <span>Save user data</span>
          </v-tooltip>


          <v-btn
            style="color: white"
            color="blue"
            :disabled="!unsavedData"
            @click="openSaveUserDataModal"
          >
            <v-icon medium>
              save
            </v-icon>
            &nbsp; SAVE USER DATA
          </v-btn>


          <v-btn
            style="color: white"
            color="red"
            @click="openDeleteUserDataModal"
          >
            <v-icon medium>
              delete
            </v-icon>
            &nbsp; DELETE USER DATA
          </v-btn>

          <div>
            <v-layout
              row
              wrap
            >
              <v-flex>
                <v-btn
                  style="color: white"
                  :color="cognitoUserPoolData.Enabled ? 'grey' : 'green'"
                  @click="openLockUserDataModal"
                >
                  <v-icon
                    v-if="cognitoUserPoolData.Enabled"
                    medium
                  >
                    lock
                  </v-icon>
                  <v-icon
                    v-if="!cognitoUserPoolData.Enabled"
                    medium
                  >
                    lock_open
                  </v-icon>
                  <span v-if="cognitoUserPoolData.Enabled">
                    &nbsp; LOCK USER
                    <h6 ml12>User is:
                      <span class="color: green"><b>Enabled</b></span>
                    </h6>
                  </span>
                  <span v-if="!cognitoUserPoolData.Enabled">
                    &nbsp; UNLOCK USER <br>
                    <h6 ml12>User is:
                      <span class="color: red"><b>Disabled</b></span>
                    </h6>
                  </span>
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-layout>
        <v-card>
          <v-container
            fluid
            grid-list-sm
          >
            <h6 class="title">
              General Information
            </h6>
            <br>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs6
                sm3
              >
                <v-select
                  v-model="user.title"
                  :items="onboardingTitlesArray"
                  item-text="name"
                  item-value="value"
                  label="Title"
                  @change="e => onSelectChange(e, 'title')"
                />
              </v-flex>

              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="firstName"
                  label="First Name"
                  :value="user.firstName"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="lastName"
                  label="Last Name"
                  :value="user.lastName"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex
                xs12
                sm3
              >
                <v-radio-group
                  v-model="user.sex"
                  label="Gender"
                  row
                  wrap
                  @change="(value) => onSelectChange(value, 'sex')"
                >
                  <v-radio
                    v-for="option in genderArray"
                    :key="option.value"
                    :label="option.name"
                    :value="option.value"
                    color="info"
                  />
                </v-radio-group>
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <v-autocomplete
                  v-model="user.citizenship"
                  :items="countryCodesArray"
                  :search-input.sync="citizenship"
                  item-text="name"
                  item-value="backendValue"
                  label="Citizenship"
                  @change="e => onSelectChange(e, 'citizenship')"
                />
              </v-flex>
            </v-layout>
            <h6 class="title">
              Address Information
            </h6>
            <br>
            <v-layout
              v-if="user.address"
              row
              wrap
            >
              <v-flex
                xs12
                md4
              >
                <user-info
                  name="street"
                  label="Street"
                  :value="user.address.street"
                  :on-change="e => onObjectChange(e, 'address')"
                />
              </v-flex>
              <v-flex
                xs12
                md4
              >
                <user-info
                  name="streetNo"
                  label="Street Number"
                  :value="user.address.streetNo"
                  :on-change="e => onObjectChange(e, 'address')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="streetAdditional"
                  label="Street Additional"
                  :value="user.address.streetAdditional"
                  :on-change="e => onObjectChange(e, 'address')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="postalCode"
                  label="Postal Code"
                  :value="user.address.postalCode"
                  :on-change="e => onObjectChange(e, 'address')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="city"
                  label="City"
                  :value="user.address.city"
                  :on-change="e => onObjectChange(e, 'address')"
                />
              </v-flex>
              <v-flex
                xs12
                md4
              >
                <v-autocomplete
                  v-model="user.address.country"
                  :items="countryCodesArray"
                  :search-input.sync="countryOfResidence"
                  item-text="name"
                  item-value="backendValue"
                  label="Country of Residence"
                  @change="e => onSelectObjectChange(e, 'address', 'country')"
                />
              </v-flex>
            </v-layout>
            <h6 class="title">
              Birth Information
            </h6>
            <br>
            <v-layout
              v-if="user.birth"
              row
              wrap
            >
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="dateOfBirth"
                  label="Date of birth"
                  :value="user.birth.dateOfBirth"
                  :is-error="!validateDate(user.birth.dateOfBirth)"
                  :on-change="e => onObjectChange(e, 'birth')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="placeOfBirth"
                  label="Place of birth"
                  :value="user.birth.placeOfBirth"
                  :on-change="e => onObjectChange(e, 'birth')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <v-autocomplete
                  v-model="user.birth.countryOfBirth"
                  :items="countryCodesArray"
                  :search-input.sync="countryOfBirth"
                  item-text="name"
                  item-value="backendValue"
                  label="Country of birth"
                  @change="e => onSelectObjectChange(e, 'birth', 'countryOfBirth')"
                />
              </v-flex>
            </v-layout>
            <h6 class="title">
              Additional Information
            </h6>
            <br>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                sm4
              >
                <v-autocomplete
                  v-model="user.taxableCountry"
                  :items="countryCodesArray"
                  :search-input.sync="taxableCountry"
                  item-text="name"
                  item-value="backendValue"
                  label="Taxable Country"
                  @change="e => onSelectChange(e, 'taxableCountry')"
                />
              </v-flex>
              <v-flex
                xs12
                md4
              >
                <v-select
                  v-model="user.maritalStatus"
                  :items="maritalStatusArray"
                  item-text="name"
                  item-value="value"
                  label="Marital Status"
                  @change="e => onSelectChange(e, 'maritalStatus')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="taxId"
                  label="Tax"
                  :value="user.taxId"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="phone"
                  label="Phone"
                  :value="user.phone"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="phoneMobile"
                  label="Mobile Phone"
                  :value="user.phoneMobile"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="friendId"
                  label="Friend Id"
                  :value="user.friendId"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="affiliatedPartnerId"
                  label="Affiliated Partner Id"
                  :value="user.affiliatedPartnerId"
                  :on-change="onChange"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="milesId"
                  label="Miles & More Servicekartennr"
                  :value="user.milesId"
                  :on-change="onChange"
                />
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                sm4
              >
                <v-checkbox
                  id="isUSTaxed"
                  v-model="user.isUSTaxed"
                  label="I am taxable in the USA"
                  @change="e => onSelectChange(e, 'isUSTaxed')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <v-checkbox
                  id="isPEP"
                  v-model="user.isPEP"
                  label="I am a politically exposed person (PEP)."
                  @change="e => onSelectChange(e, 'isPEP')"
                />
              </v-flex>

              <v-flex
                xs12
                sm4
              >
                <v-checkbox
                  id="isPEPVerified"
                  v-model="user.isPEPVerified"
                  label="Is PEP verified."
                  @change="e => onSelectChange(e, 'isPEPVerified')"
                />
              </v-flex>
            </v-layout>
            <h6 class="title">
              Legimitation Document
            </h6>
            <br>
            <v-layout
              v-if="user.legitimationDocument"
              row
              wrap
            >
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="number"
                  label="Document number"
                  :value="user.legitimationDocument.number"
                  :on-change="e => onObjectChange(e, 'legitimationDocument')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="authority"
                  label="Issuing authority"
                  :value="user.legitimationDocument.authority"
                  :on-change="e => onObjectChange(e, 'legitimationDocument')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="createdAt"
                  label="Created At"
                  :value="user.legitimationDocument.createdAt"
                  :is-error="!validateDate(user.legitimationDocument.createdAt)"
                  :on-change="e => onObjectChange(e, 'legitimationDocument')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="expiresAt"
                  label="Expires at"
                  :value="user.legitimationDocument.expiresAt"
                  :is-error="!validateDate(user.legitimationDocument.expiresAt)"
                  :on-change="e => onObjectChange(e, 'legitimationDocument')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <v-autocomplete
                  v-model="user.legitimationDocument.countryOfIssue"
                  :items="countryCodesArray"
                  :search-input.sync="countryOfIssue"
                  item-text="name"
                  item-value="backendValue"
                  label="Country of issue"
                  @change="e => onSelectObjectChange(e, 'legitimationDocument', 'countryOfIssue')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <v-select
                  v-model="user.legitimationDocument.type"
                  :items="legitimationOnboardingDocumentArray"
                  item-text="name"
                  item-value="value"
                  label="Legitimation document"
                  @change="e => onSelectObjectChange(e, 'legitimationDocument', 'type')"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <v-alert
          v-if="error"
          type="error"
          :value="true"
          class="mt-2"
        >
          {{ error }}
        </v-alert>
      </v-expansion-panel-content>
      <!-- Information User Metadata end -->

      <!-- Information User Terms and Conditions -->
      <v-expansion-panel-content>
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            Cognito Information
          </h6>
        </template>
        <v-layout v-show="cognitoUser.cognito_id">
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                fixed
                dark
                fab
                bottom
                right
                color="warning"
                :disabled="!unsavedUserCognito"
                v-on="on"
                @click="openSaveUserCognitoModal"
              >
                <v-icon>save</v-icon>
              </v-btn>
            </template>
            <span>Save user Cognito</span>
          </v-tooltip>

          <v-btn
            style="color: white"
            color="blue"
            :disabled="!unsavedUserCognito"
            @click="openSaveUserCognitoModal"
          >
            <v-icon medium>
              save
            </v-icon>
            &nbsp; SAVE USER COGNITO
          </v-btn>
        </v-layout>
        <v-card v-show="!cognitoUser.cognito_id">
          <v-container
            fluid
            grid-list-sm
          >
            <h6 class="title">
              No Cognito user found
            </h6>
          </v-container>
        </v-card>
        <v-card v-show="cognitoUser.cognito_id">
          <v-container
            fluid
            grid-list-sm
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="cognitoId"
                  :readonly="true"
                  label="Cognito Id"
                  :value="cognitoUser.cognito_id"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="userId"
                  :readonly="true"
                  label="User Id"
                  :value="cognitoUser.user_id"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="defaultRegion"
                  :readonly="true"
                  label="Default Region"
                  :value="cognitoUser.default_region"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="email"
                  label="Email"
                  :value="cognitoUser.email"
                  :on-change="onChangeCognitoModel"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="user_pool_id"
                  :readonly="true"
                  label="User Pool Id"
                  :value="cognitoUser.user_pool_id"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="user_pool_status"
                  :readonly="true"
                  label="User Pool Status"
                  :value="cognitoUserPoolData.UserStatus"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="user_pool_enabled"
                  :readonly="true"
                  label="User Pool Enabled"
                  :value="cognitoUserPoolData.Enabled"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="user_pool_created_date"
                  :readonly="true"
                  label="User Created At"
                  :value="cognitoUserPoolData.UserCreateDate"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <v-alert
          v-if="error"
          type="error"
          :value="true"
          class="mt-2"
        >
          {{ error }}
        </v-alert>
      </v-expansion-panel-content>
      <!-- Information User Terms and Conditions end-->

      <!-- Information User Cognito -->
      <v-expansion-panel-content v-show="termsAndConditionsData.length > 0">
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            Terms and Conditions
          </h6>
        </template>
        <v-layout>
          <v-spacer />
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-container
                v-for="(item, index) in termsAndConditionsData"
                :key="index"
                grid-list-md
              >
                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs8
                    text-xs-left
                  >
                    <div>
                      <span>Domain:</span>
                      <br>
                      <b
                        v-if="item.domain_toc_version"
                        class="ml-1"
                      >{{ item.domain_toc_version.split('_')[0] }}</b>
                      <b
                        v-else
                        class="ml-1"
                      >user.exporo</b>
                    </div>
                    <div>
                      <span>Date of acceptance:</span>
                      <br>
                      <b
                        v-if="item.domain_toc_version"
                        class="ml-1"
                      >{{ formatDateWithHour(item.toc_version) }}</b>
                      <b
                        v-if="!item.domain_toc_version &&
                          cognitoUserPoolData &&
                          cognitoUserPoolData.UserCreateDate"
                        class="ml-1"
                      >{{ formatDateWithHour(cognitoUserPoolData.UserCreateDate) }}</b>
                    </div>
                    <div>
                      <span>Version:</span>
                      <br>
                      <b
                        v-if="item.domain_toc_version"
                        class="ml-1"
                      >{{ item.domain_toc_version.split('_')[1] }}</b>
                      <b
                        v-else
                        class="ml-1"
                      >{{ item.toc_version }}</b>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </template>
            <span>Save user Cognito</span>
          </v-tooltip>
        </v-layout>
        <v-alert
          v-if="error"
          type="error"
          :value="true"
          class="mt-2"
        >
          {{ error }}
        </v-alert>
      </v-expansion-panel-content>
      <!-- Information User Cognito end -->

      <!-- Legal User Data -->
      <v-expansion-panel-content v-show="legalUser">
        <template v-slot:header>
          <h6 class="title">
            <v-icon
              class="mr-2"
            >
              assignment_ind
            </v-icon>
            Legal User Data
          </h6>
        </template>
        <v-layout v-show="legalUser">
          <v-container
            fluid
            grid-list-sm
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="authorizedToRepresentAs"
                  label="Authorized to represent as"
                  :value="legalUser.authorizedToRepresentAs"
                  :on-change="e => onObjectChange(e, 'legalUser')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="companyName"
                  label="Company name"
                  :value="legalUser.companyName"
                  :on-change="e => onObjectChange(e, 'legalUser')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <v-select
                  v-model="legalUser.companyType"
                  name="companyType"
                  :items="companyTypeArray"
                  item-text="name"
                  item-value="value"
                  label="Type of company"
                  @change="e => onSelectObjectChange(e, 'legalUser', 'companyType')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="companyRegisterNo"
                  label="Commercial register number"
                  :value="legalUser.companyRegisterNo"
                  :on-change="e => onObjectChange(e, 'legalUser')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="companyLocalCourt"
                  label="Responsible local court"
                  :value="legalUser.companyLocalCourt"
                  :on-change="e => onObjectChange(e, 'legalUser')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="taxNumber"
                  label="Tax number"
                  :value="legalUser.taxNumber"
                  :on-change="e => onObjectChange(e, 'legalUser')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="taxOffice"
                  label="Responsible tax office"
                  :value="legalUser.taxOffice"
                  :on-change="e => onObjectChange(e, 'legalUser')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="phone"
                  label="Company phone number"
                  :value="legalUser.phone"
                  :on-change="e => onObjectChange(e, 'legalUser')"
                />
              </v-flex>
            </v-layout>
            <h6 class="title">
              Address Information
            </h6>
            <br>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                md4
              >
                <user-info
                  name="street"
                  label="Street"
                  :value="legalUser.address ? legalUser.address.street : null"
                  :on-change="e => onLegalUserAddressObjectChange(e, 'legalUser')"
                />
              </v-flex>
              <v-flex
                xs12
                md4
              >
                <user-info
                  name="streetNo"
                  label="Street Number"
                  :value="legalUser.address ? legalUser.address.streetNo : null"
                  :on-change="e => onLegalUserAddressObjectChange(e, 'legalUser')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="streetAdditional"
                  label="Street Additional"
                  :value="legalUser.address ? legalUser.address.streetAdditional : null"
                  :on-change="e => onLegalUserAddressObjectChange(e, 'legalUser')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="postalCode"
                  label="Postal Code"
                  :value="legalUser.address ? legalUser.address.postalCode : null"
                  :on-change="e => onLegalUserAddressObjectChange(e, 'legalUser')"
                />
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <user-info
                  name="city"
                  label="City"
                  :value="legalUser.address ? legalUser.address.city : null"
                  :on-change="e => onLegalUserAddressObjectChange(e, 'legalUser')"
                />
              </v-flex>
              <v-flex
                xs12
                md4
              >
                <v-autocomplete
                  v-model="legalUser.address.country"
                  :items="countryCodesArray"
                  :search-input.sync="legalUserAddressCountry"
                  item-text="name"
                  item-value="backendValue"
                  label="Country"
                  @change="e => onLegalUserAddressSelectObjectChange(e, 'legalUser', 'country')"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
        <v-alert
          v-if="error"
          type="error"
          :value="true"
          class="mt-2"
        >
          {{ error }}
        </v-alert>
      </v-expansion-panel-content>
      <!-- al User Dat end -->
    </v-expansion-panel>
    <!-- Signings end -->

    <v-dialog
      v-model="modalOpen"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title
          v-if="deleteUser"
          class="headline grey lighten-2"
          primary-title
        >
          Confirm customer data deletion?
        </v-card-title>

        <v-card-title
          v-if="lockUser"
          class="headline grey lighten-2"
          primary-title
        >
          Confirm lock user?
        </v-card-title>

        <v-card-title
          v-if="!deleteUser && !lockUser"
          class="headline grey lighten-2"
          primary-title
        >
          Confirm customer data change?
        </v-card-title>

        <v-form
          ref="processOrderForm"
          @submit.prevent="saveUserData"
        >
          <v-divider />
          <p
            v-if="deleteUser"
            class="text-xs-justify ma-2"
          >
            This action will permanently delete all user/onboarding data for:
            {{ user.firstName }} - {{ user.lastName }} - {{ user.id }}.
            Please make sure you want to proceed.
          </p>

          <p
            v-if="lockUser"
            class="text-xs-justify ma-2"
          >
            This action will lock user login for:
            {{ user.firstName }} - {{ user.lastName }} - {{ user.id }}.
            User data will remain in the system. Please make sure you want to proceed.
          </p>

          <p
            v-if="!deleteUser && !lockUser"
            class="text-xs-justify ma-2"
          >
            Please make sure this data change will not affect other processes
            regarding this cutomer. Type user ID: {{ user.id }} in field below to confirm this
            change.
          </p>

          <v-text-field
            v-model="userIdConfirmValue"
            :error-messages="userIdConfirmError"
            class="text-xs-justify ma-2"
            label="User ID"
            required
          />
          <v-alert
            v-if="isDateWronglyFormatted()"
            :value="true"
            type="error"
          >
            Please check the dates (date of birth and/or legitimation document expiresAt and/or createdAt).
          </v-alert>
          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="modalOpen = false; deleteUser = false; lockUser = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              text="Save"
              :disabled="isDateWronglyFormatted()"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import { Button } from '@/components/shared';
import { countryCodesArray } from '@/enum/CountryCodesEnum';
import { maritalStatusArray } from '@/enum/user/MaritalStatus';
import { onboardingTitlesArray } from '@/enum/user/Title';
import { genderArray } from '@/enum/user/Gender';
import { legitimationOnboardingDocumentArray } from '@/enum/user/LegitimationOnboardingDocument';
import { companyTypeArray } from '@/enum/user/CompanyType';
import OnboardingUserTables from '@/enum/user/OnboardingUserTables';

import UserInfo from './UserInfo.vue';

export default {
  name: 'UserDetailComponent',
  components: {
    'user-info': UserInfo,
    'e-button': Button,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    legalUser: {
      type: Object,
      default: () => ({ address: {} }),
    },
    cognitoUser: {
      type: Object,
      default: () => ({}),
    },
    termsAndConditionsData: {
      type: Array,
      default: () => ([]),
    },
    cognitoUserPoolData: {
      type: Object,
      default: () => ({}),
    },
    onChangeUser: {
      type: Function,
      default: () => ({}),
    },
    getData: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      error: null,
      panel: [],
      modalOpen: false,
      unsavedData: false,
      unsavedUserCognito: false,
      pickerBirthDateOpen: false,
      pickerCreatedAtOpen: false,
      pickerPassExpiresAtOpen: false,
      todaysDate: new Date().toISOString().substr(0, 10),
      userIdConfirmValue: '',
      country: '',
      countryOfBirth: '',
      countryOfResidence: '',
      legalUserAddressCountry: '',
      citizenship: '',
      taxableCountry: '',
      countryOfIssue: '',
      userIdConfirmError: '',
      countrySearch: '',
      countryOfBirthSearch: '',
      countryOfPassSearch: '',
      citizenshipSearch: '',
      taxableCountrySearch: '',
      tableName: '',
      cognitoUserToSave: {},
      countryCodesArray,
      maritalStatusArray,
      onboardingTitlesArray,
      genderArray,
      legitimationOnboardingDocumentArray,
      companyTypeArray,
      dataToSave: {},
      deleteUser: false,
      lockUser: false,
    };
  },
  computed: {
  },
  mounted() {
    this.panel = [true];
    this.legalUser.address = this.legalUser.address ? this.legalUser.address : {};
    this.dataToSave.legalUser = { address: {} };
  },
  methods: {
    ...mapActions(['updateOnboardingUserData', 'updateOnboardingUserCognito', 'deleteOnboardingUserData', 'lockOnboardingUserCognito']),
    formatDate(date) {
      return date ? this.$moment(date).format('YYYY-MM-DD') : null;
    },
    formatDateWithHour(date) {
      return date ? this.$moment(date).format('YYYY-MM-DD hh:mm:ss') : null;
    },
    formatDateLabel(date) {
      return date ? this.$moment(date).format('Do MMMM, YYYY') : null;
    },
    goToBaaderSNRPage(snr) {
      this.$router.push({ name: 'baader_detail', params: { snr } });
    },
    onChange(data) {
      this.unsavedData = true;
      this.dataToSave[data.name] = data.value;
      this.onChangeUser(data);
    },
    onChangeCognitoModel(data) {
      this.unsavedUserCognito = true;
      this.cognitoUserToSave[data.name] = data.value;
    },
    onObjectChange(data, property) {
      this.unsavedData = true;
      this.dataToSave[property] = {
        ...this.dataToSave[property],
        [data.name]: data.value,
      };
      this.onChangeUser({ name: property, value: this.dataToSave[property] });
    },
    onLegalUserAddressObjectChange(data, property) {
      this.unsavedData = true;
      this.dataToSave[property].address = {
        ...this.dataToSave[property].address || {},
        [data.name]: data.value,
      };
      this.onChangeUser({ name: property, value: this.dataToSave[property] });
    },
    isDateWronglyFormatted() {
      if (!this.validateDate(this.user.birth.dateOfBirth)
        || !this.validateDate(this.user.legitimationDocument.createdAt)
        || !this.validateDate(this.user.legitimationDocument.expiresAt)) {
        return true;
      }

      return false;
    },
    validateDate(data) {
      if (!data) {
        return true;
      }
      const regexDate = new RegExp(/^\d{4}-\d{1,2}-\d{1,2}$/);

      return regexDate.test(this.$moment(data).format('YYYY-MM-DD'));
    },
    onSelectChange(value, field) {
      this.unsavedData = true;
      this.dataToSave[field] = value;
      this.onChangeUser({ name: field, value });
    },
    onSelectObjectChange(value, property, field) {
      this.unsavedData = true;
      this.dataToSave[property] = {
        ...this.dataToSave[property],
        [field]: value,
      };
      this.onChangeUser({ name: property, value: this.dataToSave[property] });
    },
    onLegalUserAddressSelectObjectChange(value, property, field) {
      this.unsavedData = true;
      this.dataToSave[property].address = {
        ...this.dataToSave[property].address,
        [field]: value,
      };
      this.onChangeUser({ name: property, value: this.dataToSave[property] });
    },
    onDatePickerChange(date, field) {
      this.unsavedData = true;
      this.dataToSave[field] = date;
      this.closePickers();
      this.onChangeUser({ name: field, value: this.$moment(date).format('YYYY-MM-DD hh:mm:ss') });
    },
    async saveUserData() {
      this.error = null;
      if (this.userIdConfirmValue === String(this.user.id)) {
        this.userIdConfirmError = '';
        this.userIdConfirmValue = '';
        this.modalOpen = false;
        try {
          if (this.tableName === OnboardingUserTables.USER_META_TABLE) {
            this.dataToSave.id = this.user.id;
            if (this.deleteUser) {
              await this.deleteOnboardingUserData(this.dataToSave);
            } else {
              await this.updateOnboardingUserData(this.dataToSave);
            }

            this.unsavedData = false;
            this.dataToSave = {};
          } else if (this.tableName === OnboardingUserTables.COGNITO_USER) {
            this.cognitoUserToSave.id = this.user.id;
            if (this.lockUser) {
              this.cognitoUserToSave.value = !this.cognitoUserPoolData.Enabled;
              await this.lockOnboardingUserCognito(this.cognitoUserToSave);
            } else {
              await this.updateOnboardingUserCognito(this.cognitoUserToSave);
            }

            this.unsavedUserCognito = false;
            this.cognitoUserToSave = {};
          }
          await this.getData();
        } catch (error) {
          const errorResponse = _.first(_.get(error, 'response.data'));
          this.error = _.get(errorResponse, 'message');
        }
      } else {
        this.userIdConfirmError = 'Does not match User ID.';
      }
    },
    openSaveUserDataModal() {
      this.tableName = OnboardingUserTables.USER_META_TABLE;
      this.modalOpen = true;
    },
    openDeleteUserDataModal() {
      this.deleteUser = true;
      this.tableName = OnboardingUserTables.USER_META_TABLE;
      this.modalOpen = true;
    },
    openLockUserDataModal() {
      this.lockUser = true;
      this.tableName = OnboardingUserTables.COGNITO_USER;
      this.modalOpen = true;
    },
    openSaveUserCognitoModal() {
      this.tableName = OnboardingUserTables.COGNITO_USER;
      this.modalOpen = true;
    },
    closePickers() {
      this.pickerBirthDateOpen = false;
      this.pickerCreatedAtOpen = false;
      this.pickerPassExpiresAtOpen = false;
    },
  },
};
</script>

<style lang='scss' scoped>
.subheading {
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/users/onboarding/UserDetailComponent.vue